import { SPACING_24, SpacingVertical } from 'mailup-web-components'
import Footer from 'Pages/Workflow/components/Step3/Footer'
import { resetStepCallback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import { useEffect } from 'react'
import { useRecoilCallback } from 'recoil'

import WorkflowBuilder from './Step3/WorkflowBuilder'

const WorkflowWizardThirdStep = () => {
  const resetStep = useRecoilCallback(resetStepCallback, [])

  useEffect(() => {
    return () => {
      resetStep()
    }
  }, [])

  return (
    <div>
      <WorkflowBuilder />
      <SpacingVertical variant={SPACING_24} />
      <Footer />
    </div>
  )
}

export default WorkflowWizardThirdStep
